/* Bull Ring Fabrics — print repeat finder, shared by the planners (dress, curtains, quilt & craft, tablecloth). 2026-11-02, Abid.
   A product photo repeated as-is shows a join wherever two copies meet, and blending the edges leaves ghostly double motifs.
   Instead the photo is compared with shifted copies of itself to find the print's own repeat (across and down), and cut
   to exactly whole repeats, starting on a plain background line, with the light evened out. That tile carries on into the
   next copy with no join at all, like the printed fabric. Photos with no clear repeat (scrunched, one big motif) get null,
   and each planner keeps its own fallback.
   window.brfRepeatTile(canvas, size) -> {canvas, keep, keepY} | null    (canvas: a square crop of the photo)
   window.brfSeam.get(url) -> {url, keep} | null (no repeat) | undefined (not read yet); brfSeam.load(url) reads it and then
   fires a 'brf:seam' event on document so an open planner can redraw. */
(function () {
  if (window.brfSeam) return;
  /* Find the print's own repeat in a flat photo (2026-11-02): the photo is compared with shifted copies of itself; the
     shortest shift across and down where it lines up again is one repeat. The tile is then cut to exactly whole repeats,
     so it carries on into the next copy with no join and no blending. Returns null when the photo has no clear repeat
     (a scrunched photo, a large one-off motif), so the caller falls back to fading the edges. */
  function brfRepeatTile(src, S) {
    try {
      var M = 128, sm = document.createElement('canvas'); sm.width = sm.height = M;
      var sx = sm.getContext('2d'); sx.drawImage(src, 0, 0, M, M);
      function gray(ctx, n) { var d = ctx.getImageData(0, 0, n, n).data, g = new Float32Array(n * n), m = 0, i; for (i = 0; i < n * n; i++) { g[i] = .3 * d[i * 4] + .59 * d[i * 4 + 1] + .11 * d[i * 4 + 2]; m += g[i]; } m /= n * n; for (i = 0; i < n * n; i++) g[i] -= m; return g; }
      function corr(g, n, dx, dy, step) {
        var s = 0, a = 0, b = 0, x, y;
        for (y = 0; y + dy < n; y += step) for (x = 0; x + dx < n; x += step) { var p = g[y * n + x], q = g[(y + dy) * n + x + dx]; s += p * q; a += p * p; b += q * q; }
        return a && b ? s / Math.sqrt(a * b) : 0;
      }
      var g = gray(sx, M);
      function period(across) {
        var lo = 5, hi = Math.floor(M * .62), c = [], i, best = 0;
        for (i = 0; i <= hi; i++) c.push(i < lo ? 0 : corr(g, M, across ? i : 0, across ? 0 : i, 1));
        for (i = lo; i < hi; i++) if (c[i] > best) best = c[i];
        if (best < .4) return 0;
        for (i = lo + 1; i < hi; i++) if (c[i] >= c[i - 1] && c[i] >= c[i + 1] && c[i] >= best * .85) return i; /* the first strong peak */
        return 0;
      }
      var px0 = period(true), py0 = period(false); if (!px0 || !py0) return null;
      /* refine on the full photo: the coarse shift is only good to a few pixels */
      /* softened first (shrunk to a third and back): the weave of a close-up photo (linen, canvas) is fine noise that hides the print's
         repeat at full size (Abid's bee linen, 2026-11-02) */
      var sf = document.createElement('canvas'), q3 = Math.max(32, Math.round(S / 3)); sf.width = sf.height = q3; sf.getContext('2d').drawImage(src, 0, 0, q3, q3);
      var bl = document.createElement('canvas'); bl.width = bl.height = S; var blx = bl.getContext('2d'); blx.imageSmoothingQuality = 'high'; blx.drawImage(sf, 0, 0, S, S);
      var F = gray(blx, S), r = S / M;
      function refine(p0, across) {
        var bestP = 0, bestC = -1, lo = Math.floor((p0 - 1.2) * r), hi = Math.ceil((p0 + 1.2) * r);
        for (var p = lo; p <= hi; p++) { var cc = corr(F, S, across ? p : 0, across ? 0 : p, 3); if (cc > bestC) { bestC = cc; bestP = p; } }
        return {p: bestP, c: bestC};
      }
      var X = refine(px0, true), Y = refine(py0, false);
      if (X.c < .55 || Y.c < .55) return null;
      /* whole repeats, close to square, at least a sixth of the photo across */
      var bx = 1, by = 1, err = 9;
      for (var nx = 1; nx * X.p <= S; nx++) for (var ny = 1; ny * Y.p <= S; ny++) {
        var w = nx * X.p, h = ny * Y.p; if (Math.max(w, h) < S / 10) continue;
        var e = Math.abs(Math.log(w / h)) + Math.max(w, h) / S * .25; /* fewest repeats: a photo's slight skew adds up across many */ if (e < err) { err = e; bx = nx; by = ny; }
      }
      var W = bx * X.p, H = by * Y.p, out = document.createElement('canvas'); out.width = out.height = S;
      var ox = out.getContext('2d'); ox.imageSmoothingQuality = 'high'; /* start the cut on the quietest line across and down (plain background), so any tiny misfit hides there */
      function quiet(across, P, from) {
        var bestO = 0, bestE = 1e18;
        for (var o = 0; o < P; o++) { var e = 0, k = from + o, t; for (t = 0; t < S; t += 2) { var v = across ? F[t * S + k] : F[k * S + t]; e += v * v; } if (e < bestE) { bestE = e; bestO = k; } }
        return bestO;
      }
      var x0 = quiet(true, X.p, Math.floor((S - W) / 2)), y0 = quiet(false, Y.p, Math.floor((S - H) / 2));
      if (x0 + W > S) x0 -= X.p; if (y0 + H > S) y0 -= Y.p;
      ox.drawImage(src, Math.max(0, x0), Math.max(0, y0), W, H, 0, 0, S, S);
      /* even out the light: a photo is often brighter on one side, which would show as bands where tiles meet.
         Fit a flat slope of brightness across the tile (a + b·x + c·y) and divide it out. */
      var id = ox.getImageData(0, 0, S, S), d = id.data, n = 0, sL = 0, sX = 0, sY = 0, sXL = 0, sYL = 0, sXX = 0, sYY = 0, x, y, i;
      for (y = 0; y < S; y += 2) for (x = 0; x < S; x += 2) { i = (y * S + x) * 4; var l = .3 * d[i] + .59 * d[i + 1] + .11 * d[i + 2], u = x / S - .5, v = y / S - .5; n++; sL += l; sXL += u * l; sYL += v * l; sXX += u * u; sYY += v * v; }
      var a0 = sL / n, b0 = sXL / sXX, c0 = sYL / sYY;
      for (y = 0; y < S; y++) for (x = 0; x < S; x++) { i = (y * S + x) * 4; var k = a0 / Math.max(10, a0 + b0 * (x / S - .5) + c0 * (y / S - .5)); d[i] = Math.min(255, d[i] * k); d[i + 1] = Math.min(255, d[i + 1] * k); d[i + 2] = Math.min(255, d[i + 2] * k); }
      ox.putImageData(id, 0, 0);
      return {canvas: out, keep: W / S, keepY: H / S};
    } catch (e) { return null; }
  }
  window.brfRepeatTile = brfRepeatTile;
  var C = {};
  window.brfSeam = {
    get: function (url) { var c = url && C[url]; return c && c.done ? c.val : undefined; },
    load: function (url) {
      if (!url || C[url]) return; var c = C[url] = { done: false, val: null };
      var im = new Image(); im.crossOrigin = 'anonymous';
      function fin(v) { c.done = true; c.val = v; try { document.dispatchEvent(new CustomEvent('brf:seam', { detail: { url: url } })); } catch (e) {} }
      im.onerror = function () { fin(null); };
      im.onload = function () {
        try {
          var side = Math.min(im.naturalWidth, im.naturalHeight), N = Math.min(900, side), cv = document.createElement('canvas'); cv.width = cv.height = N;
          var x = cv.getContext('2d'); x.imageSmoothingQuality = 'high'; x.drawImage(im, (im.naturalWidth - side) / 2, (im.naturalHeight - side) / 2, side, side, 0, 0, N, N);
          var r = brfRepeatTile(cv, N); if (!r) return fin(null);
          var done = function (u) { fin(u ? { url: u, keep: r.keep, keepY: r.keepY } : null); };
          if (r.canvas.toBlob && window.URL && URL.createObjectURL) r.canvas.toBlob(function (b) { done(b ? URL.createObjectURL(b) : r.canvas.toDataURL('image/jpeg', .9)); }, 'image/jpeg', .9);
          else done(r.canvas.toDataURL('image/jpeg', .9));
        } catch (e) { fin(null); } /* a photo from another site can't be read */
      };
      im.src = url;
    }
  };
})();
